<template>
  <div>
  </div>
</template>
<script>
  export default {
    data(){
      return{
        code:'',
        refer:'',
      }
    },
    async created(){
      document.title=this.$t('dl')
      let code = this.$route.query.code
			this.refer = this.$route.query.refer
			let userToken = this.$route.query.token||this.$route.query.userToken
      // let userKeyEncryption = this.$route.query.encry
      // if(userKeyEncryption){
      //   userToken = decodeURIComponent(atob(userKeyEncryption))
      // }
			if(userToken){
				this.$axios.get('/api/sso/v0.1/ssoLogin',{params:{userToken}})
				.then(res=>{
					localStorage.setItem('uGuid',String(res.data.userInfo.uGuid))
					localStorage.setItem('userNo',res.data.userInfo.persionId)
					localStorage.setItem('uName',res.data.userInfo.uName)
					localStorage.setItem('userInfo',JSON.stringify(res.data.userInfo))
					localStorage.setItem('auditToken',res.data.data)
					this.Cookie.set('uGuid',res.data.userInfo.uGuid)
					this.Cookie.set('userNo',res.data.userInfo.persionId)
					this.Cookie.set('uName',res.data.userInfo.uName)
					this.Cookie.set('userInfo',JSON.stringify(res.data.userInfo))
					this.Cookie.set('auditToken',res.data.data)
          if(this.refer){
            window.location.href = decodeURIComponent(this.refer)
          }else{
					  window.location.href = this.Config.tsUrl+'/app/index'
          }
				})
				return
			}
      // let uGuid = this.Cookie.get('uGuid')
      // if(uGuid&&uGuid!='null'&&uGuid!='undefined'){
      //   await this.$axios.get('/api/sso?validUser=true').then(async res=>{
      //     if(res.data&&res.data.length==32&&res.data==this.Cookie.get('uGuid')){
      //       this.toRefer()
      //     }
      //   })
      // }
      if(window.h5sdk){
			console.log(window.h5sdk.getSystemInfo())
        // 免登
        window.h5sdk.ready(() => { // ready 方法不需要每次都调用。
          tt.requestAuthCode({
            appId: this.Config.fsAppId,
            success: (info) => {
              // alert('免登成功')
              this.loginByCode(info.code)
            },
            fail: (error) => {
              console.error(error)
              this.saomaLogin(this.refer)
            }
          });
				});
        return
      }
      if(code){
        this.loginByCode(code)
        return
      }
      // 飞书扫码
      this.saomaLogin(this.refer)
    },
    methods:{
      saomaLogin(refer){
        // 原飞书
        // window.location.href = 'https://open.work.sany.com.cn/open-apis/authen/v1/user_auth_page?redirect_uri='+encodeURIComponent(window.location.origin+'/login?refer='+encodeURIComponent(refer))+'&app_id='+this.Config.fsAppId+'&state=index'
        // saas飞书
        window.location.href = 'https://open.feishu.cn/open-apis/authen/v1/user_auth_page?redirect_uri='+encodeURIComponent(window.location.origin+'/login?refer='+encodeURIComponent(refer))+'&app_id='+this.Config.fsAppId+'&state=index'
      },
      loginByCode(code){
        this.$axios.get('/api/sso/v0.1/fsLogin',
        {
          params:{
						code:code,
						isTs:true
          }
        }).then(res=>{
          if(res.data&&res.data.userInfo.uGuid){
            localStorage.setItem('uGuid',String(res.data.userInfo.uGuid))
            localStorage.setItem('userNo',res.data.userInfo.persionId)
            localStorage.setItem('uName',res.data.userInfo.uName)
            localStorage.setItem('userInfo',JSON.stringify(res.data.userInfo))
						localStorage.setItem('auditToken',res.data.data)
            this.Cookie.set('uGuid',res.data.userInfo.uGuid)
            this.Cookie.set('userNo',res.data.userInfo.persionId)
            this.Cookie.set('uName',res.data.userInfo.uName)
            this.Cookie.set('userInfo',JSON.stringify(res.data.userInfo))
						this.Cookie.set('auditToken',res.data.data)
            let token = res.data.data
            if(this.refer&&this.refer.indexOf('?')==-1){
              this.refer = this.refer+'?'
            }
						this.refer = this.refer+'&token='+token
						console.log('登录成功',this.refer)
            // alert('登录成功')
            this.toRefer()
          }else{
						console.log('登录失败')
						console.log(res)
            // alert('登录失败')
          }
        })
      },
      toRefer(){
        let url = this.refer
        if((!this.refer)||this.refer.indexOf('/audit/login')!=-1){
          url = window.location.origin+'/audit/showToPc'
        }
        // alert(url)
        window.location.href=url
      }
    }
  }
</script>
